import { ChangeDetectorRef, Component } from '@angular/core';
import { DataService } from './../../../services/data/data.service';

import { calculos, CommonVariables, FuncionesMes, formatear } from '../../funciones/funcionesGenerales';

import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { cuenta, cobertura, variableTemp, variable, cuentasP, varTP, varP, opciones } from '../tablaslds';

import { CookieService } from 'ngx-cookie-service';
import { IMG } from '../../../services/imagen/png';
// import { ExcelService } from 'src/app/services/exportar/excel/excel.service';
import moment from 'moment';
import { ServiciosRiegosService } from '../../../services/riesgo-liquidez/servicios-riegos.service';
import { FiltersM, typesApex } from '../../../components/models';
import { companiesRiesgoLiquidez } from '../../../shared/catalogos';
import { firstValueFrom } from 'rxjs';
import { messages } from '../../funciones/mensajes';
import { ExcelService } from '../../../services/excel/excel.service';

@Component({
  selector: 'app-cobertura-rcl',
  templateUrl: './cobertura-rcl.component.html',
  styleUrl: './cobertura-rcl.component.css'
})
export class CoberturaRCLComponent {
  Filters= FiltersM;
  /* Evaluaciones */
  private numEvaluaciones = 1;
  private numEvaluacionesGraf = 12;
  /*Obtención de datos consultas*/
  private idPlantilla = 7;
  private periodosSeleccionados = 0;
  /*Titulos y subtitulos*/
  public subTitles = '';
  public subTitles2 = [];
  public subTitlesGraf = '';
  /*Variables filtros*/
  public Periodos = [];
  public cadenaEvaluacion = [];
  /* Arreglos */
  public dataOrdenado = [];
  public dataAll = [];
  public dataAllPromedio = [];
  public porcent = 50;
  public icl:string;
  public dataGraf = [];
  public datosGraficas = [];

  public options: any = {};
  public chart;
  public chart2;
  public verGraf = false;
  public colorMulti: any = ['#2843A0','#15A075','#36CAE8','#78EAD2','#F88476','#E23E6A'];
  public colorMono: any = ['#76C4D5'];
  public suffix = 'Gs';
  public miles = ',';
  public decimal = '.';
  public tipoGraf = ''
  public etiquetas = false;

  idInst;
  idAdmin;
  private adicionales = [];
  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private service: ServiciosRiegosService,
    private cdr: ChangeDetectorRef,
    private excelService: ExcelService
  ) {
    formatear.momentAbrev();
    if(this.cookieService.get('reload') === 'true'){
      this.cookieService.set('reload','false', {path: '/'})
      location.reload();
    }
    this.idInst = this.cookieService.get('idInstitucion');
    this.idAdmin = companiesRiesgoLiquidez.find(c => c.id === this.idInst)?.idAdmin ?? '';
    var instAT = companiesRiesgoLiquidez.find(c => c.id === this.idInst);
    this.idPlantilla = instAT.idPlantilla;
    this.getEvaluaciones();
  }

  ngOnInit(): void {}
  /* Consultas */
  private async getEvaluaciones(){
    const data = await this.service.getEvaluaciones(this.idPlantilla);
    this.ordenamientoDataEvaluacion([].concat(data.evaluaciones));
  }
  private getDataPromedios(eva, graf?){
    var val = [], periodos = 0;
    for(var an=this.Periodos.length-1; an>=0;an--){
      for(var mes=this.Periodos[an].series.length-1; mes>=0; mes--){
        if(this.Periodos[an].series[mes].id === eva && periodos === 0){
          val.push(this.Periodos[an].series[mes]);
          periodos++;
        }else if(this.Periodos[an].series[mes].check && periodos < 3 && periodos !== 0){
          val.push(this.Periodos[an].series[mes]);
          periodos++;
        }
      }
    }
    this.getPromQueryCuentas(val, eva, graf);
  }
  private async getPromQueryCuentas(arreglo, eva, graf?){
    var variables;
    let datos = [];
    for(const val of cuentasP){
      switch(arreglo.length){
        case 1:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[0].id, 
            idEvaluacion3: arreglo[0].id, 
            idCuenta: val, 
          }
        break;
        case 2:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[1].id,
            idEvaluacion3: arreglo[0].id, 
            idCuenta: val, 
          }
        break;
        case 3:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[1].id, 
            idEvaluacion3: arreglo[2].id, 
            idCuenta: val, 
          }
        break;
      }
      
      const data = await this.service.getCuentasPromedio(variables)
      var pro = [];
      switch(arreglo.length){
        case 1:
          pro = [data.val1.valor];
        break;
        case 2:
          pro = [data.val1.valor,data.val2.valor];
        break;
        case 3:
          pro = [data.val1.valor,data.val2.valor,data.val3.valor];
        break;
      }
      datos.push({
        id: data.val1.idCuenta,
        valor: pro,
        idEvaluacion: data.val1.idEvaluacion,
        descripcion: '',
      });
      this.getPromQueryVarTemp(arreglo, datos, eva, graf);
    }
  }
  private async getPromQueryVarTemp(arreglo, datos, eva, graf?){
    var variables;
    for(const val of varTP){
      switch(arreglo.length){
        case 1:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[0].id, 
            idEvaluacion3: arreglo[0].id, 
            idVarTemp: val, 
          }
        break;
        case 2:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[1].id,
            idEvaluacion3: arreglo[0].id, 
            idVarTemp: val, 
          }
        break;
        case 3:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[1].id, 
            idEvaluacion3: arreglo[2].id, 
            idVarTemp: val, 
          }
        break;
      }
      const data = await this.service.getVarTempPromedio(variables)
      var pro = [];
      switch(arreglo.length){
        case 1:
          pro = [data.val1.valor];
        break;
        case 2:
          pro = [data.val1.valor,data.val2.valor];
        break;
        case 3:
          pro = [data.val1.valor,data.val2.valor,data.val3.valor];
        break;
      }
      datos.push({
        id: data.val1.idVarTemp,
        valor: pro,
        idEvaluacion: data.val1.idEvaluacion,
        descripcion: '',
      });
      this.getPromQueryVar(arreglo, datos, eva, graf)
    }
  }
  private async getPromQueryVar(arreglo, datos, eva, graf?){
    var variables;
    for(const val of varP){
      switch(arreglo.length){
        case 1:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[0].id, 
            idEvaluacion3: arreglo[0].id, 
            idVariable: val, 
          }
        break;
        case 2:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[1].id,
            idEvaluacion3: arreglo[0].id, 
            idVariable: val, 
          }
        break;
        case 3:
          variables = { 
            idEvaluacion1: arreglo[0].id, 
            idEvaluacion2: arreglo[1].id, 
            idEvaluacion3: arreglo[2].id, 
            idVariable: val, 
          }
        break;
      }
      const data = await this.service.getVarPromedio(variables)
      var pro = [];
      switch(arreglo.length){
        case 1:
          pro = [data.val1.valor];
        break;
        case 2:
          pro = [data.val1.valor,data.val2.valor];
        break;
        case 3:
          pro = [data.val1.valor,data.val2.valor,data.val3.valor];
        break;
      }
      datos.push({
        id: data.val1.idVariable,
        valor: pro,
        idEvaluacion: data.val1.idEvaluacion,
        descripcion: '',
      });
      this.dataAllPromedio.push({
        data: datos,
        eva: eva
      });
      this.getInversiones(eva, graf);
    }
  }
  private async getInversiones(eva, graf?){
    var datos = [];
    let sel = this.cadenaEvaluacion.filter(per => per.idEvaluacion === eva)[0];
    const per = sel.an+'-'+FuncionesMes.f_switchmes3(sel.mes)+'-01';
    const data = await this.service.getInversiones1(per);
    datos.push({
      id: 'INV1',
      valor: data.inversiones_sub_calculos['INV_01'].de_1_7+data.inversiones_sub_calculos['INV_01'].de_8_15+data.inversiones_sub_calculos['INV_01'].de_16_30,
      idEvaluacion: eva,
    });
    this.getAsientos(datos, eva, graf);
  }
  private async getAsientos(datos, eva, graf?){
    let sel = this.cadenaEvaluacion.filter(per => per.idEvaluacion === eva)[0];
    const per = sel.an+'-'+FuncionesMes.f_switchmes3(sel.mes)+'-01';
    const data = await this.service.getAsientos(per);
    datos.push({
      id: 'ASI1',
      valor: data.creditos_sub_calculos['ASI_01'].de_1_7+data.creditos_sub_calculos['ASI_01'].de_8_15+data.creditos_sub_calculos['ASI_01'].de_16_30,
      idEvaluacion: eva,
    });
    datos.push({
      id: 'ASI2',
      valor: data.creditos_sub_calculos['ASI_02'].de_1_7+data.creditos_sub_calculos['ASI_02'].de_8_15+data.creditos_sub_calculos['ASI_02'].de_16_30,
      idEvaluacion: eva,
    });
    this.getDataLiquidez(datos, eva, graf);
  }
  private async getDataLiquidez(datos, eva, graf?){
    let sel = this.cadenaEvaluacion.filter(per => per.idEvaluacion === eva)[0];
    const per = sel.an+'-'+FuncionesMes.f_switchmes3(sel.mes)+'-01';
    const data = await this.service.getLiquidez(per);
    const dat = data.liquidaciones_sub_calculos;
    datos.push({
      id: 'LIQ_01',
      valor: dat.LIQ_01.de_1_7 + dat.LIQ_01.de_8_15 + dat.LIQ_01.de_16_30,
      idEvaluacion: eva,
    });
    datos.push({
      id: 'LIQ_02',
      valor: dat.LIQ_02.de_1_7 + dat.LIQ_02.de_8_15 + dat.LIQ_02.de_16_30,
      idEvaluacion: eva,
    });
    this.getDataAhorros(datos, eva, graf);
  }
  private async getDataAhorros(datos, eva, graf?){
    let sel = this.cadenaEvaluacion.filter(per => per.idEvaluacion === eva)[0];
    const per = sel.an+'-'+FuncionesMes.f_switchmes3(sel.mes)+'-01';
    const data = await this.service.getAhorros(per);
    const dat = data.ahorros_sub_calculos; 

    datos.push({
      id: 'AHO_02',
      valor: dat.AHO_02.de_1_7 + dat.AHO_02.de_8_15 + dat.AHO_02.de_16_30,
      idEvaluacion: eva,
    });
    datos.push({
      id: 'AHO_03',
      valor: dat.AHO_03/30*7 + dat.AHO_03/30*8 +dat.AHO_03/30*15,
      idEvaluacion: eva,
    });
    datos.push({
      id: 'AHO_04',
      valor: dat.AHO_04/30*7 + dat.AHO_04/30*8 +dat.AHO_04/30*15,
      idEvaluacion: eva,
    });
    datos.push({
      id: 'AHO_05',
      valor: dat.AHO_05/30*7 + dat.AHO_05/30*8 +dat.AHO_05/30*15,
      idEvaluacion: eva,
    });
    this.getDataCuentas(datos, eva, graf);
  }
  private async getDataCuentas(datos, eva, graf?){
    let i=0;
    for(const val of cuenta){
      const data = await this.service.getDetalleCuenta(eva, val);
      datos.push({
        id: data.detalleEvaluacionCuenta.idCuenta,
        valor: data.detalleEvaluacionCuenta.valor,
        idEvaluacion: data.detalleEvaluacionCuenta.idEvaluacion,
      });
    }
    this.getVariables(datos, eva, graf);
  }
  private async getVariables(datos,eva, graf?){
    for(const val of variable){
      const data = await this.service.getVariable(eva, val);
      datos.push({
        id: data.detalleEvaluacionVariable.idVariable,
        valor: data.detalleEvaluacionVariable.valor,
        idEvaluacion: data.detalleEvaluacionVariable.idEvaluacion,
      });
    }
    await this.getAdicionales();
    this.getVariablesTemp(datos, eva, graf);
  }
  private async getAdicionales(){
    this.adicionales = [];
    const data = await this.service.getAditionals("2023-01-01", `editable_4`);
    const datos = data.creditos_sub_calculos.adicionales;
    var aux = [];
    for ( const dat of datos ) {
      const per = moment( dat.periodo.split('T')[0] ).format('YYYY-MM');
      const ex = aux.find( i => i.periodo === per);
      if( aux.length === 0 || !ex ){
        var por = [];
        for( const inf of opciones){
          por.push( dat.propiedades.ASI_01[inf].value );
        }
        aux.push({
          periodo: per,
          porcentaje: por,
          calculo: `editable_4`,
        });
      }
    }
    this.adicionales = [...this.adicionales, ...aux];
    this.adicionales.sort( function (a,b) {
      if ( moment(a.periodo, 'YYYY-MM').isAfter(moment(b.periodo, 'YYYY-MM') ) )
        return -1;
      if ( moment(a.periodo, 'YYYY-MM').isAfter(moment(b.periodo, 'YYYY-MM') ) )
        return 1;
      return 0;
    });
  }
  private async getVariablesTemp(datos,eva, graf?){
    this.dataGraf = [];
    this.datos['data'] = [];
    this.evaluaciones = [];
    for(const val of variableTemp){
      const data = await this.service.getDetalleVarTemp(eva, val); 

      datos.push({
        id: data.detalleEvaluacionVarTemp.idVarTemp,
        valor: data.detalleEvaluacionVarTemp.valor,
        idEvaluacion: data.detalleEvaluacionVarTemp.idEvaluacion,
      });
    }
    if(graf===undefined){
        this.getDataTabla(datos);
        this.datosGraficas.push({
          data: datos,
          eva: eva
        });
        if(this.datosGraficas.length === this.cadenaEvaluacion.length){
          this.iterarDatosGraf();
        }else{
          for(const data of  this.cadenaEvaluacion){
            const existe = this.datosGraficas.filter(ev => ev.eva === data.idEvaluacion);
            if(existe.length===0){
              this.getDataPromedios(data.idEvaluacion, 'graf');
              break;
            }
          }
        }
      }else{
        this.datosGraficas.push({
          data: datos,
          eva: eva
        });
        if(this.datosGraficas.length === this.cadenaEvaluacion.length){
          this.iterarDatosGraf();
        }else{
          for(const data of  this.cadenaEvaluacion){
            const existe = this.datosGraficas.filter(ev => ev.eva === data.idEvaluacion);
            if(existe.length===0){
              this.getDataPromedios(data.idEvaluacion, 'graf');
              break;
            }
          }
        }
      }
  }
  private iterarDatosGraf(){
    for(const dat of this.datosGraficas){
      this.getDataTablaVal(dat.data, dat.eva);
    }
  }

  //Consultas riesgos
  private async getDataRiesgos(eva){
    this.dataGraf = [];
    this.datos['data'] = [];
    this.evaluaciones = [];
    var periodoSelec;
    this.Periodos.forEach( e => {
      const ex = e.series.find(m => m.id === eva);
      if(ex){
        periodoSelec = ex;
      }
    });
    try{
      const rcl = await this.service.getRCL(this.idAdmin, periodoSelec.nmes, periodoSelec.an);
      if(rcl.length !== 0){
        const rclF = rcl.map(e =>{
          return {
            id: e.name,
            ...e
          }
        })
        const cuentasAT = cobertura.cuentasAT(this.idPlantilla);
        if(Object.keys(cuentasAT).length == 0){
          var nombre = companiesRiesgoLiquidez.find(c => Number(c.id) === Number(this.idInst)).name;
          messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
        }else{
          await this.agregarACuentasTotal(
            cuentasAT['cuentas'],
            eva,
            this.service.getDetalleCuenta.bind(this.service),
            'detalleEvaluacionCuenta',
            'idCuenta',
            rclF
          );

          await this.agregarACuentasTotal(
            cuentasAT['varTemp'],
            eva,
            this.service.getDetalleVarTemp.bind(this.service),
            'detalleEvaluacionVarTemp',
            'idVarTemp',
            rclF
          );

          await this.agregarACuentasTotal(
            cuentasAT['var'],
            eva,
            this.service.getVariable.bind(this.service),
            'detalleEvaluacionVariable',
            'idVariable',
            rclF
          );
          if(this.datosGraficas.length === 0){
            this.getDataTabla(rclF);
            this.datosGraficas.push({
              data: rclF,
              eva: eva
            });
            if(this.datosGraficas.length === this.cadenaEvaluacion.length){
              this.iterarDatosGraf();
            }else{
              for(const data of  this.cadenaEvaluacion){
                const existe = this.datosGraficas.filter(ev => ev.eva === data.idEvaluacion);
                if(existe.length===0){
                  this.getDataRiesgos(data.idEvaluacion);
                  break;
                }
              }
            }
          }else{
            this.datosGraficas.push({
              data: rclF,
              eva: eva
            });
            if(this.datosGraficas.length === this.cadenaEvaluacion.length){
              this.iterarDatosGraf();
            }else{
              for(const data of  this.cadenaEvaluacion){
                const existe = this.datosGraficas.filter(ev => ev.eva === data.idEvaluacion);
                if(existe.length===0){
                  this.getDataRiesgos(data.idEvaluacion);
                  break;
                }
              }
            }
          }
        }
      }
    }catch(err){}
  }
  private async agregarACuentasTotal<T>(cuentas: string[],idEvaluacion: number,servicio: (idEval: number, id: string) => Promise<any>,
    detalleKey: string, idKey: string, cuentasTotal:any[]) {
    const promesas = cuentas.map(id =>
      servicio(idEvaluacion, id)
    );
    const resultados = await Promise.all(promesas);
    resultados.forEach(r => {
      const detalle = r?.[detalleKey];
      if (!detalle) return;
      const idCuenta = detalle[idKey];
      cuentasTotal.push({
        id: detalle[idKey],
        name: detalle[idKey],
        valor: detalle.valor,
        anio: this.cadenaEvaluacion.find(i => i.idEvaluacion === idEvaluacion).an,
        mes: this.cadenaEvaluacion.find(i => i.idEvaluacion === idEvaluacion).mesNum
      });
    });
  }
  /* Obtener data tabla */
  private getDataTabla(data){
    this.dataAll = data;
    this.dataOrdenado = [];
    var dataTabla = [], aux = [];
    for(var i = 1; ;i++){
      const dat = cobertura.tabla(this.idPlantilla,i);
      if(dat === undefined){
        break;
      }else{
        let dta = dat[0], value = 0;
        if(dta.codigo !== 'suma' && dta.codigo !== 'encabezado' && dta.codigo !== 'subtot'){
          if(dta.codigo !== ''){
            if(dta.prom){
              value = this.getPromedio(dta, this.cadenaEvaluacion[0].idEvaluacion);
            }else{
              if(dta.manual){
                const per1 = moment( this.cadenaEvaluacion[0].evaluacion, 'MMM YY' );
                const val = data.find(e => e.name === dta.codigo);
                const per2 = moment( `${val.mes} ${val.anio}`, 'MM YYYY')

                if(!per1.isSame(per2, 'month')){
                  val.value = 0;
                  val.valor = 0;
                }
              }
              value = calculos.calculos(dta.codigo, data);
              if(dta.gap){
                const per = moment( this.cadenaEvaluacion[0].evaluacion, 'MMM YY' );
                const a = this.adicionales.find( ad => moment(ad.periodo, 'YYYY-MM').isSameOrBefore(per, 'month') )
                if ( a ) {
                  var valAux = 0;
                  for( var pos = 0; pos < 3; pos++ ){
                    valAux += a.porcentaje[pos];
                  }
                  value = value * valAux; 
                }else{
                  value = 0;
                }
              }
            }
          }
          aux.push({
            concepto: dta.concepto,
            factor: dta.factor,
            saldo: value,
            admisible: (value*dta.factor)/100,
            codigo: dta.codigo
          });
        }else if(dta.codigo === 'encabezado'){
          aux.push({
            concepto: dta.concepto,
            factor: 0,
            saldo: 0,
            admisible: 0,
            codigo: dta.codigo
          });
        }else if(dta.codigo === 'subtot'){
          let s=0, a=0;
          for(const val of aux){
            s+=val.saldo;
            a+=val.admisible;
          }
          aux.push({
            concepto: dta.concepto,
            factor: '',
            saldo: s,
            admisible: a,
            codigo: dta.codigo
          });
        }else{
          let s=0, a=0;
          for(const val of aux){
            if(val.codigo!=='subtot' && dta.codigo !== 'encabezado'){
              s+=val.saldo;
              a+=val.admisible;
            }
          }
          aux.push({
            concepto: dta.concepto,
            factor: '',
            saldo: s,
            admisible: a,
            codigo: dta.codigo
          });
          dataTabla.push(aux);
          aux=[];
        }
      }
    }
    this.dataOrdenado = this.dataOrdenado.concat(dataTabla);
    this.getDataTabFinal();
  }
  private getDataTabFinal(){
    var aux=[];
    aux.push({
      concepto: 'Activos líquidos de alta calidad',
      factor: '',
      saldo: this.dataOrdenado[0][this.dataOrdenado[0].length-1].admisible,
      admisible: '',
      codigo: 't',
      rowspan: 1
    });
    aux.push({
      concepto: 'Salidas de efectivo totales',
      factor: '',
      saldo: this.dataOrdenado[1][this.dataOrdenado[1].length-1].admisible,
      admisible: '',
      codigo: 't',
      rowspan: 2
    });
    aux.push({
      concepto: 'Entradas de efectivo totales',
      factor: '',
      saldo: this.dataOrdenado[2][this.dataOrdenado[2].length-1].admisible,
      admisible: 'Máx. nivel de entradas / salidas',
      codigo: 't',
      rowspan: 0
    });
    var por = 0;
    if(this.dataOrdenado[1][this.dataOrdenado[1].length-1].admisible !== 0){
      por = Number((this.dataOrdenado[2][this.dataOrdenado[2].length-1].admisible/this.dataOrdenado[1][this.dataOrdenado[1].length-1].admisible*100).toFixed(2));
    }
    aux.push({
      concepto: '% de entradas de efectivo sobre salidas de efectivo',
      factor: '',
      saldo: por,
      admisible: this.porcent,
      codigo: 'e',
      rowspan: 1
    });
    let text = '0';
    if(this.dataOrdenado[1][this.dataOrdenado[1].length-1].admisible !== 0){
      if(por <= 75){
        text = 'Sin ajuste';
      }else{
        text = (this.dataOrdenado[1][this.dataOrdenado[1].length-1].admisible*75/100).toFixed(0)
      }
    }
    let por2 = 0;
    if(this.dataOrdenado[1][this.dataOrdenado[1].length-1].admisible !== 0 && this.porcent !== 0){
      por2 = this.dataOrdenado[1][this.dataOrdenado[1].length-1].admisible*this.porcent/100;
    }
    aux.push({
      concepto: 'Entradas de efectivo ajustadas',
      factor: 75,
      saldo: text,
      admisible: por2,
      codigo: 'r',
      rowspan: 1
    });
    let text2 = 0;
    if(this.dataOrdenado[1][this.dataOrdenado[1].length-1].admisible !== 0){
      if(por < 75){
        text2=Number(((this.dataOrdenado[0][this.dataOrdenado[0].length-1].admisible
          +this.dataOrdenado[2][this.dataOrdenado[2].length-1].admisible)
          /this.dataOrdenado[1][this.dataOrdenado[1].length-1].admisible*100).toFixed(0))
      }else{
        if(text === 'Sin ajuste'){
          text2=Number(((this.dataOrdenado[0][this.dataOrdenado[0].length-1].admisible)/this.dataOrdenado[1][this.dataOrdenado[1].length-1].admisible*100).toFixed(0));
        }else{
          text2=Number(((this.dataOrdenado[0][this.dataOrdenado[0].length-1].admisible+Number(text))/this.dataOrdenado[1][this.dataOrdenado[1].length-1].admisible*100).toFixed(0))
        }
      }
    }
    let por3 = 0;
    if(this.dataOrdenado[1][this.dataOrdenado[1].length-1].admisible !== 0 && por2 !== 0){
      por3 = Number(((this.dataOrdenado[0][this.dataOrdenado[0].length-1].admisible
        +por2)
        /this.dataOrdenado[1][this.dataOrdenado[1].length-1].admisible*100).toFixed(0))
    }
    aux.push({
      concepto: 'Ratio de cobertura de Liquidez (RCL)',
      factor: '',
      saldo: text2,
      admisible: por3,
      codigo: 'p',
      rowspan: 1
    });
    this.icl = `${text2} %`;
    this.dataOrdenado.push(aux);
  }
  /* valores Grafica */
  private getDataTablaVal(data, eva){
    this.dataAll = data;
    var dataTabla = [], aux = [];
    for(var i = 1; ;i++){
      const dat = cobertura.tabla(this.idPlantilla,i);
      if(dat === undefined){
        break;
      }else{
        let dta = dat[0], value = 0;
        if(dta.codigo !== 'suma' && dta.codigo !== 'encabezado' && dta.codigo !== 'subtot'){
          if(dta.codigo !== ''){
            if(dta.prom){
              value = this.getPromedio(dta, eva);
            }else{
              if(dta.manual){
                const per1 = moment( this.cadenaEvaluacion.find(e => e.idEvaluacion === eva).evaluacion, 'MMM YY' );
                const val = data.find(e => e.name === dta.codigo);
                const per2 = moment( `${val.mes} ${val.anio}`, 'MM YYYY')

                if(!per1.isSame(per2, 'month')){
                  val.value = 0;
                  val.valor = 0;
                }
              }
              value = calculos.calculos(dta.codigo, data);
              if(dta.gap){
                const per = moment( this.cadenaEvaluacion[0].evaluacion, 'MMM YY' );
                const a = this.adicionales.find( ad => moment(ad.periodo, 'YYYY-MM').isSameOrBefore(per, 'month') )
                if ( a ) {
                  var valAux = 0;
                  for( var pos = 0; pos < 3; pos++ ){
                    valAux += a.porcentaje[pos];
                  }
                  value = value * valAux; 
                }else{
                  value = 0;
                }
              }
            }
          }
          aux.push({
            concepto: dta.concepto,
            factor: dta.factor,
            saldo: value,
            admisible: (value*dta.factor)/100,
            codigo: dta.codigo
          });
        }else if(dta.codigo === 'encabezado'){
          aux.push({
            concepto: dta.concepto,
            factor: 0,
            saldo: 0,
            admisible: 0,
            codigo: dta.codigo
          });
        }else if(dta.codigo === 'subtot'){
          let s=0, a=0;
          for(const val of aux){
            s+=val.saldo;
            a+=val.admisible;
          }
          aux.push({
            concepto: dta.concepto,
            factor: '',
            saldo: s,
            admisible: a,
            codigo: dta.codigo
          });
        }else{
          let s=0, a=0;
          for(const val of aux){
            if(val.codigo!=='subtot' && dta.codigo !== 'encabezado'){
              s+=val.saldo;
              a+=val.admisible;
            }
          }
          aux.push({
            concepto: dta.concepto,
            factor: '',
            saldo: s,
            admisible: a,
            codigo: dta.codigo
          });
          dataTabla.push(aux);
          aux=[];
        }
      }
    }
    this.getDataTabFinalVal(dataTabla, eva);
  }
  private getDataTabFinalVal(dataTabla, eva){
    var aux=[];
    aux.push({
      concepto: 'Activos líquidos de alta calidad',
      factor: '',
      saldo: dataTabla[0][dataTabla[0].length-1].admisible,
      admisible: 'Estrés',
      codigo: 't',
      rowspan: 1
    });
    aux.push({
      concepto: 'Salidas de efectivo totales',
      factor: '',
      saldo: dataTabla[1][dataTabla[1].length-1].admisible,
      admisible: 'Máx. nivel de entradas / salidas',
      codigo: 't',
      rowspan: 2
    });
    aux.push({
      concepto: 'Entradas de efectivo totales',
      factor: '',
      saldo: dataTabla[2][dataTabla[2].length-1].admisible,
      admisible: 'Máx. nivel de entradas / salidas',
      codigo: 't',
      rowspan: 0
    });
    var por = 0;
    if(dataTabla[1][dataTabla[1].length-1].admisible !== 0){
      por = Number((dataTabla[2][dataTabla[2].length-1].admisible/dataTabla[1][dataTabla[1].length-1].admisible*100).toFixed(2));
    }
    aux.push({
      concepto: '% de entradas de efectivo sobre salidas de efectivo',
      factor: '',
      saldo: por,
      admisible: this.porcent,
      codigo: 'e',
      rowspan: 1
    });
    let text = '0';
    if(dataTabla[1][dataTabla[1].length-1].admisible !== 0){
      if(por <= 75){
        text = 'Sin ajuste';
      }else{
        text = (dataTabla[1][dataTabla[1].length-1].admisible*75/100).toFixed(0)
      }
    }
    let por2 = 0;
    if(dataTabla[1][dataTabla[1].length-1].admisible !== 0 && this.porcent !== 0){
      por2 = dataTabla[1][dataTabla[1].length-1].admisible*this.porcent/100;
    }
    
    aux.push({
      concepto: 'Entradas de efectivo ajustadas',
      factor: 75,
      saldo: text,
      admisible: por2,
      codigo: 'r',
      rowspan: 1
    });
    let text2 = 0;
    if(dataTabla[1][dataTabla[1].length-1].admisible !== 0){
      if(por < 75){
        text2=Number(((dataTabla[0][dataTabla[0].length-1].admisible
          +dataTabla[2][dataTabla[2].length-1].admisible)
          /dataTabla[1][dataTabla[1].length-1].admisible*100).toFixed(0))
      }else{
        if(text === 'Sin ajuste'){
          text2=Number(((dataTabla[0][dataTabla[0].length-1].admisible)/dataTabla[1][dataTabla[1].length-1].admisible*100).toFixed(0));
        }else{
          text2=Number(((dataTabla[0][dataTabla[0].length-1].admisible+Number(text))/dataTabla[1][dataTabla[1].length-1].admisible*100).toFixed(0))
        }
      }
    }
    let por3 = 0;
    if(dataTabla[1][dataTabla[1].length-1].admisible !== 0 && por2 !== 0){
      por3 = Number(((dataTabla[0][dataTabla[0].length-1].admisible
        +por2)
        /dataTabla[1][dataTabla[1].length-1].admisible*100).toFixed(0))
    }
    aux.push({
      concepto: 'Ratio de cobertura de Liquidez (RCL)',
      factor: '',
      saldo: text2,
      admisible: por3,
      codigo: 'p',
      rowspan: 1
    });
    this.dataGraf.push({
      value: text2,
      name: this.cadenaEvaluacion.filter(evl => evl.idEvaluacion === eva)[0].evaluacion
    });
    this.evaluaciones.push(this.cadenaEvaluacion.filter(evl => evl.idEvaluacion === eva)[0].evaluacion)
    this.datos['data'].push(text2);
    this.cdr.detectChanges();
    if(this.dataGraf.length === this.cadenaEvaluacion.length){      
      this.verGraf = true;
    }
  }
  datos: any = {
    data: [],
    name: 'Evolución'
  };
  evaluaciones = [];
  typeGraph = typesApex.BARHORIZONTAL;
  modal = false;
  private opcionesGrafica(arreglo, tipo){
    switch(tipo){
      case 'line':
        this.typeGraph = typesApex.LINE;
        break;
      case 'area':
        this.typeGraph = typesApex.AREA;
        break;
      case 'bar':
        this.typeGraph = typesApex.BARHORIZONTAL;
        break;
    }
    this.tipoGraf = tipo;
    this.verGraf = true;
    let data = [], categories = [], values = [];
    for(const dat of arreglo){
      values.push(dat.value);
      categories.push(dat.name);
    }
    data.push({
      name: arreglo[0].name,
      data: values,
    })
    // if(this.verGraf){
    //   this.chart.destroy()
    // }
    // this.options = {
    //   chart: {
    //     width: "100%",
    //     height: "100%",
    //     type: tipo,
    //     toolbar: {
    //       show: false
    //     },
    //     animations: {
    //       enabled: false,
    //       easing: 'easeinout',
    //       speed: 800,
    //       animateGradually: {
    //           enabled: false,
    //       },
    //       dynamicAnimation: {
    //           enabled: false,
    //       }
    //     },
    //     zoom: {
    //       enabled: false
    //     }
    //   },
    //   plotOptions:{
    //     bar:{
    //       horizontal: true,
    //     }
    //   },
    //   colors: this.colorMono,
    //   fill:{
    //     opacity: 0.5
    //   },
    //   dataLabels: {
    //     enabled: false
    //   },
    //   series: data,
    //   xaxis: {
    //     categories: categories,
    //     tooltip: {
    //       enabled: false
    //     }
    //   },
    //   yaxis: {
    //     style: {
    //       fontSize: '12px',
    //       fontFamily: 'Roboto',
    //       fontWeight: 600,
    //     },
    //     labels: {
    //       formatter: (value) => { 
    //         if(tipo === 'bar')
    //           return value;
    //         var val = formatear.retornarformatolefty(value);
    //         var dat = val.split(' ');
    //         return  formatear.retornarformatoval(dat[0],dat[1],dat[2],this.miles, this.decimal);
    //       },
    //     }
    //   },
    //   tooltip:{
    //     enabled: true,
    //     followCursor: false,
    //     theme: "dark",
    //   },
    //   grid: {
    //     show: false
    //   },
    //   markers: {
    //     size: 6,
    //     hover: {
    //       size: 6
    //     },
    //     fillOpacity: 0.7
    //   },
    //   stroke:{
    //     show: true,
    //     with: [0, 4],
    //     curve: "smooth"
    //   },

    // };
    // if(tipo === 'bar'){
    //   this.options.stroke["show"] = false;
    // }else{
    //   this.options.stroke["show"] = true;
    // }
    // setTimeout( ()=>{
    //   this.chart = new ApexCharts(
    //     document.querySelector("#chart"),
    //     this.options
    //   );
    //   this.chart.render();
    // },100);
  }
  private opcionesGraficaMuestra(arreglo, tipo){
    let data = [], categories = [], values = [];
    this.tipoGraf = tipo + '-s';
    if(this.verGraf){
      this.chart.destroy()
    }
    this.options = {
      chart: {
        width: "100%",
        height: "100%",
        type: tipo,
        toolbar: {
          show: false
        },
        animations: {
          enabled: false,
          easing: 'easeinout',
          speed: 800,
          animateGradually: {
              enabled: false,
          },
          dynamicAnimation: {
              enabled: false,
          }
        },
        zoom: {
          enabled: false
        }
      },
      plotOptions:{
        bar:{
          horizontal: true,
        }
      },
      colors: this.colorMono,
      fill:{
        opacity: 0.5
      },
      dataLabels: {
        enabled: false
      },
      series: [
        {
          name: "basic",
          data: [264, 266, 268, 250, 270, 257, 288, 245, 260, 266, 268, 250]
        }
      ],
      xaxis: {
        categories: [
          "ene 23",
          "feb 23",
          "mar 23",
          "abr 23",
          "may 23",
          "jun 23",
          "jul 23",
          "ago 23",
          "sep 23",
          "oct 23",
          "nov 23",
          "dic 23"
        ],
        tooltip: {
          enabled: false
        }
      },
      yaxis: {
        style: {
          fontSize: '12px',
          fontFamily: 'Roboto',
          fontWeight: 600,
        },
        labels: {
          formatter: (value) => { 
            if(tipo === 'bar')
              return value;
            var val = formatear.retornarformatolefty(value);
            var dat = val.split(' ');
            return  formatear.retornarformatoval(dat[0],dat[1],dat[2],this.miles, this.decimal);
          },
        }
      },
      tooltip:{
        enabled: true,
        followCursor: false,
        theme: "dark",
      },
      grid: {
        show: false
      },
      markers: {
        size: 6,
        hover: {
          size: 6
        },
        fillOpacity: 0.7
      },
      stroke:{
        show: true
      },

    };
    if(tipo === 'bar'){
      this.options.stroke["show"] = false;
    }else{
      this.options.stroke["show"] = true;
    }
    this.chart = new ApexCharts(
      document.querySelector("#chart"),
      this.options
    );
    this.chart.render();
    this.verGraf = true;
  }
  public changeGrafic(val){
    switch(val){
      case 'line':
      case 'area':
        setTimeout(() =>{ 
          this.opcionesGrafica(this.dataGraf, val);
        }, 100);
      break;
      case 'bar':
        setTimeout(() =>{ 
          this.opcionesGrafica(this.dataGraf, val);
        }, 100);
      break;
      case 'bar-s':
        setTimeout(() =>{ 
          this.opcionesGraficaMuestra(this.dataGraf, 'bar');
        }, 100);
      break;
      case 'area-s':
        setTimeout(() =>{ 
          this.opcionesGraficaMuestra(this.dataGraf, 'area');
        }, 100);
      break;
    }
  }
  /* */
  public async cambioPorcen(){
    var inputValue = this.porcent, introdujo: any, guardo = false;
    
    await Swal.fire({
      title: 'Ingresa el procentaje máximo',
      text: "",
      input: 'number',
      inputValue: inputValue,
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (Number(value) > 100) {
          return 'El porcentaje no puede exceder el 100%';
        }
        guardo = true;
        this.porcent = Number(value);
        this.dataOrdenado.pop();
        this.getDataTabFinal();
        return '';
      }
    });
  }
  private getPromedio(esp, eva){
    var val = 0
    const valores = this.dataAllPromedio.filter(dat => dat.eva === eva)[0].data
    if(valores){
      for(var i=0; i<valores[0].valor.length; i++){
        val += calculos.calculosProm(esp.codigo, valores, i)
      }
      let p = val/valores[0].valor.length;
      val = (p*7/30)+(p*8/30)+(p*15/30);
      return val;
    }
    return 0;
  }
  /*Obtención de Periodos*/
  private ordenamientoDataEvaluacion(datos){
    //const info = CommonVariables.obtenerPeriodos(datos, this.numEvaluaciones);
    const info = CommonVariables.obtenerPeriodos(datos, this.numEvaluaciones);
    this.Periodos = info.periodos;
    for(const an of this.Periodos){
      if(an.anio < 2023){
        an.utilizable = false;
      }
    }
    this.periodosSeleccionados = info.perSel;
    this.obtenerDataEvaluacion();
  }
  /* Obtener la cadena de evaluación */
  private obtenerDataEvaluacion(){
    this.cadenaEvaluacion = [];
    this.subTitles = "";
    this.subTitles2 = [];
    var tot=0;
    for(var i = this.Periodos.length-1; i>=0; i--){
      if(this.Periodos[i].utilizable){
        for(var j = this.Periodos[i].series.length-1; j>=0; j--){
          if(this.Periodos[i].series[j].check || (tot<12 && tot !==0)){
            this.cadenaEvaluacion.push({
              evaluacion: this.Periodos[i].series[j].periodo,
              idEvaluacion: this.Periodos[i].series[j].id,
              porcentaje: '%',
              pos: this.Periodos[i].series[j].pos,
              an: this.Periodos[i].series[j].an,
              mes: this.Periodos[i].series[j].mes,
              numMes: this.Periodos[i].series[j].nmes
            });
            this.subTitles2.push(this.Periodos[i].series[j].periodo)
            tot++;
            if(tot>this.numEvaluacionesGraf){
              break;
            }
          }
        }
        if(tot>this.numEvaluacionesGraf){
          break;
        }
      }
      
    }
    var subAux = [];
    for(var i=this.subTitles2.length-1; i>=0; i--){
      subAux.push(this.subTitles2[i]);
    }
    this.subTitles2 = subAux;
    this.subTitles = this.cadenaEvaluacion[0].evaluacion;
    var eva = this.cadenaEvaluacion[0].idEvaluacion;
    this.verGraf = false;
    this.datosGraficas = [];
    this.dataAllPromedio = [];
    this.idPlantilla === 7 ? this.getDataPromedios(eva) : this.getDataRiesgos(eva)
    // this.getDataPromedios(eva);
  }
  /* acciones en filtros */
  public cambioPeriodo(per){
    for(const an of this.Periodos){
      for(const mes of an.series){
        if(mes.periodo === per.periodo){
          mes.check = true;
        }else{
          mes.check = false;
        }
      }
    }
    this.obtenerDataEvaluacion();

    // if(this.periodosSeleccionadosAct() === 1 && per.check){
    //   $("#check_"+per.mes+""+per.anio).prop('checked', true);
    // }else if( per.check || (!per.check && this.periodosSeleccionadosAct() < this.numEvaluaciones ) ){
    //   per.check = !per.check;
    //   this.obtenerDataEvaluacion();
    // }else{
    //   $("#check_"+per.mes+""+per.anio).prop('checked', false);
    //   Swal.fire({
    //     title: 'No se pueden seleccionar más de '+this.numEvaluaciones+' periodos',
    //     text: '',
    //     confirmButtonColor: '#ff6b00',
    //     confirmButtonText: this.translate.instant('swal.acep')
    //   });
    // }
  }
  private periodosSeleccionadosAct(){
    var sel = 0;
    for(const an of this.Periodos){
      for(const mes of an.series){
        if(mes.check){
          sel++;
        }
      }
    }
    return sel;
  }
  /* formateo de datos */
  public escrituraPer(Periodo){
    if(Periodo.split(' ').length === 2){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }else if(Periodo.split(' ').length === 5){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1]+' '+datos[2]+' '+this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }
    return Periodo;
  }
  public numPerSelect(){
    var selecc = 0;
    for(const an of this.Periodos){
      for(const mes of an.series){
        if(mes.check){
          selecc++;
        }
      }
    }
    if(selecc > 1)
      return true;
    return false;
  }
  /* Funciones de formateo */
  public formNum(num, dec){
    if (num !== undefined && num !== '' && num !== null){
      return CommonVariables.formatearMoneda(Math.abs(num), dec, this.miles, this.decimal);
    }
    return '';
  }
  /* Modales */
  public openModal(modal){
    // document.getElementById("ampliar")!.style.display = "block";
    this.modal = true;
    // setTimeout(() =>{ 
    //   this.chart2 = new ApexCharts(
    //     document.querySelector("#chart2"),
    //     this.options
    //   );
    //   this.chart2.render();
    // }, 100);
      
  }
  public closeModal(){
    // this.chart2.destroy();
    this.modal = false;
    // document.getElementById("ampliar")!.style.display = "none";
  }
  public clickFuera(event){
    // if (event.target === document.getElementById("ampliar")) {
      this.closeModal();
    // }
  }

  //exportar grafica en imagen 
  public exportarGrafica(id, nombre){
    
    IMG.exportimagenes(id,this.translate.instant(nombre) + " " + this.escrituraPer(this.subTitles));
  }

  public exportExcel(){
    let header1 = [this.translate.instant('liquidez.cobertura.tituloTabla1'),'','',''];
    let header2 = [
      this.translate.instant('liquidez.cobertura.ecabezadoTabla1'),
      this.translate.instant('liquidez.cobertura.ecabezadoTabla2'),
      this.translate.instant('liquidez.cobertura.ecabezadoTabla3'),
      this.translate.instant('liquidez.cobertura.ecabezadoTabla4')
    ];
    let data = [], aux = [], merge = [], encabezado = [];
    let t = 0;
    for(const tab of this.dataOrdenado){
      merge.push(true);
      encabezado.push(true)
      data.push([this.translate.instant('liquidez.cobertura.tituloTabla'+(t+2)),'','',''])
      for(const item of tab){
        merge.push(item.codigo==='encabezado'?true:false);
        encabezado.push(false)
        aux.push(item.concepto);
        aux.push(item.factor);
        aux.push(item.saldo);
        aux.push(item.admisible);
        data.push(aux);
        aux = [];
      }
      merge.push(false);
      encabezado.push(false)
      data.push(['','','','']);
      t++;
    }

    let titulo = this.translate.instant('liquidez.cobertura.tituloTabla') + ' | ' + this.escrituraPer(this.subTitles)

    this.excelService.generateCobertura(titulo, header1, header2, data, this.translate.instant('liquidez.cobertura.tituloTabla') + ' ' + this.escrituraPer(this.subTitles), merge, encabezado);
  }
}
